// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"0c61c1af","213":"c255cd5c","455":"6634a216","625":"d2e0aac4"}[chunkId] + ".chunk.js";
};